import ContentTextItem, {
	type HighlightTextSize,
} from 'components/ContentTextItem';
import { LayoutContainer } from 'components/Layout';
import type { ValidSitecoreLink } from 'components/SitecoreLink';
import type { ThemeName } from 'design-system/themes';
import type { Field, HeadingLevel } from 'models/sitecore';

interface Props {
	className?: string;
	content?: Field<string>;
	eyebrow?: Field<string>;
	heading?: Field<string>;
	headingLevel?: HeadingLevel;
	highlightText?: Field<string>;
	highlightTextSize?: HighlightTextSize;
	links?: ValidSitecoreLink[];
	theme?: ThemeName;
}

export default function Hero({
	className,
	content,
	eyebrow,
	heading,
	headingLevel = 'h2',
	highlightText,
	highlightTextSize,
	links,
	theme,
}: Props) {
	return (
		<LayoutContainer outerClassName={className}>
			<ContentTextItem
				innerClassName="mx-auto max-w-pageExtraNarrow"
				content={content?.value}
				eyebrow={eyebrow?.value}
				heading={heading?.value}
				headingLevel={headingLevel}
				highlightText={highlightText?.value}
				highlightTextSize={highlightTextSize}
				links={links}
				theme={theme}
			/>
		</LayoutContainer>
	);
}
Hero.displayName = 'Hero';
